import { Associations, AttachingFile, EducationUnal } from "./IGraduateFilterObjMsg";

export class IScheduleMessage {
    id: number = 0;
    ruleName: string = "";
    emailData?: EmailData;
    eventDate: string = "";
}

export interface IScheduleMessageState {
    scheduledMessage?: IScheduleMessage;
}


export class EmailData {
    html: string = "";
    type: string = "";
    filters?: Filters;
    preview: boolean = false;
    subject: string = "";
    associations?: Associations;
    educationUnal?: EducationUnal;
    aditionalEmails: string[] = [];
    attachingFiles: Array<AttachingFile> = [];
}

export class Filters {
    doc: string = "";
    nit: string = "";
    names: string = "";
    name: string = "";
    surname: string = "";
    state?: string[];
    gender: number = 0;
    country: number = 0;
    department: number = 0;
    city: number = 0;
    laboralSector: number = 0;
    typeOfCompany: number = 0;
    rangeUpdate?: RangeDateValues;
    rangeRegister?: RangeDateValues;
    inJobBank?: boolean;
}


export class RangeDateValues {
    sinceDate: Date = new Date();
    untilDate: Date = new Date();
}